/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { PERMISSIONS } from '@squiz/dxp-auth';
import { ICON_API, ICON_FOLDER_SPECIAL, ICON_WIDGETS, NavigationItem } from '@squiz/sds';
import { TENANT_FEATURE_FLAGS } from 'apps/console-core/src/Constants/FeatureFlags.constants';
import React from 'react';
import { AllComponents } from '../Screens/AllComponents/AllComponents';
import { ComponentDetails } from '../Screens/ComponentDetails/ComponentDetails';
import { ComponentDetailsWithinSet } from '../Screens/ComponentDetailsWithinSet/ComponentDetailsWithinSet';
import { ComponentSetDetails } from '../Screens/ComponentSetDetails/ComponentSetDetails';
import { ComponentSets } from '../Screens/ComponentSets/ComponentSets';
import { ContentMatrixIdentifiers } from '../Screens/ContentMatrixIdentifiers/ContentMatrixIdentifiers';
import { screenPaths } from './ScreenPaths.constants';
import { COMPONENT_SERVICE_STRINGS } from './Strings.constants';

/**
 * Component sets screen.
 */
export const COMPONENT_SETS: NavigationItem = {
  featureFlag: TENANT_FEATURE_FLAGS.COMPONENT_SERVICE_ACCESS,
  icon: ICON_FOLDER_SPECIAL,
  key: `component-sets`,
  label: COMPONENT_SERVICE_STRINGS.componentSets,
  path: screenPaths.componentSets,
  permission: PERMISSIONS.dxpComponents.COMPONENT_SET_READ,
  screen: <ComponentSets />,
};

/**
 * Component set details screen.
 */
export const COMPONENT_SET_DETAILS: NavigationItem = {
  devices: [],
  featureFlag: TENANT_FEATURE_FLAGS.COMPONENT_SERVICE_ACCESS,
  key: `component-set-details`,
  label: COMPONENT_SERVICE_STRINGS.componentSetDetails,
  path: screenPaths.componentSetDetails,
  permission: PERMISSIONS.dxpComponents.COMPONENT_SET_READ,
  screen: <ComponentSetDetails />,
};

/**
 * All components screen.
 */
export const ALL_COMPONENTS: NavigationItem = {
  featureFlag: TENANT_FEATURE_FLAGS.COMPONENT_SERVICE_ACCESS,
  icon: ICON_WIDGETS,
  key: `all-components`,
  label: COMPONENT_SERVICE_STRINGS.allComponents,
  path: screenPaths.allComponents,
  permission: PERMISSIONS.dxpComponents.COMPONENT_SET_READ,
  screen: <AllComponents />,
};

/**
 * Component details screen.
 */
export const COMPONENT_DETAILS: NavigationItem = {
  devices: [],
  featureFlag: TENANT_FEATURE_FLAGS.COMPONENT_SERVICE_ACCESS,
  key: `component-details`,
  label: COMPONENT_SERVICE_STRINGS.componentDetails,
  path: screenPaths.componentDetails,
  permission: PERMISSIONS.dxpComponents.COMPONENT_SET_READ,
  screen: <ComponentDetails />,
};

/**
 * Component details from within set screen.
 */
export const COMPONENT_DETAILS_WITHIN_SET: NavigationItem = {
  devices: [],
  featureFlag: TENANT_FEATURE_FLAGS.COMPONENT_SERVICE_ACCESS,
  key: `component-details-within-set`,
  label: COMPONENT_SERVICE_STRINGS.componentDetails,
  path: screenPaths.componentDetailsWithinSet,
  permission: PERMISSIONS.dxpComponents.COMPONENT_SET_READ,
  screen: <ComponentDetailsWithinSet />,
};

export const CONTENT_MATRIX_IDENTIFIERS: NavigationItem = {
  featureFlag: TENANT_FEATURE_FLAGS.COMPONENT_SERVICE_ACCESS,
  icon: ICON_API,
  key: `content-matrix-identifiers`,
  label: COMPONENT_SERVICE_STRINGS.matrixApiIdentifiers,
  path: screenPaths.contentMatrixIdentifiers,
  permission: PERMISSIONS.dxpContentStore.SETTINGS_READ,
  screen: <ContentMatrixIdentifiers />,
};
